import { Switch } from "@/components/ui/switch";
import { SectionCard } from "../SectionShell";
import { inputCls, SelectField, ToggleRow } from "./Fields";

const NETWORKS = [
  ["website", "Website URL"],
  ["youtube", "YouTube channel URL"],
  ["facebook", "Facebook page URL"],
  ["instagram", "Instagram profile URL"],
  ["email", "Email address (shown in Program Details box)"],
];

export const SocialSection = ({ content, setC }) => (
  <SectionCard id="social" testId="social-links-panel">
    <ToggleRow testId="content-social_visible" label="Connect With Us section" sub="Shows the social links block under the Zoom link on the main page" checked={content.social_visible !== false} onChange={(v) => setC("social_visible", v)} className="mb-5" />
    <div className="mb-5 max-w-md">
      <SelectField k="social_style" label="Display style" value={content.social_style || "list"} onChange={(v) => setC("social_style", v)}
        options={[["icons", "Option 1 · Icon pills (icon + handle)"], ["list", "Option 2 · Official list (platform · handle)"], ["cards", "Option 3 · Tile grid"]]} />
    </div>
    <div className="grid sm:grid-cols-2 gap-3">
      {NETWORKS.map(([k, label]) => (
        <div key={k} className="rounded-xl border border-border px-4 py-3 bg-white/50">
          <div className="flex items-center justify-between gap-3">
            <label className="text-xs uppercase tracking-widest text-muted-foreground">{label}</label>
            <Switch data-testid={`content-social_${k}_visible`} aria-label={`Toggle ${label}`} checked={content[`social_${k}_visible`] !== false} onCheckedChange={(v) => setC(`social_${k}_visible`, v)} />
          </div>
          <input data-testid={`content-social_${k}`} value={content[`social_${k}`] || ""} onChange={(e) => setC(`social_${k}`, e.target.value)} className={`${inputCls} py-2 text-sm`} />
        </div>
      ))}
    </div>
  </SectionCard>
);
